import commonGetter from '../getters/commonGetter'
import commonAction from '../actions/commonAction'
import commonMutation from '../mutations/commonMutation'

const commonModule = {
  state: {
    module: { path: 'index', titleEN: 'Welcome', titleCN: '欢迎' },
    courses: [],
    login: {},
    courseDetails: {},
    courseOpenJobs: [],
    certSearch: {},
    enterprise: {},
    employeeDegree: [],
    employeeTitle: [],
    certClass: [],
    certSubClass: [],
    jobs: [],
    learnDetails: [],
    learnApproveStep: [],
    learnPayMethod: [],
    makeUpPayMethod: [],
    makeUpDetails: [],
    makeUpApproveStep: [],
    news: [],
    newsDetails: {},
    newsTestPlans: {},
    courseRecommends: [],
    learningmgtDetails: {},
    commonJob: {},
    studyRecordDetails: {},
    invoiceApproveDetails: {},
    quickComments: [],
    weiXinTmpQrCode: {},
    invoiceTypes: [],
    invoicePayBodys: []
  },
  getters: commonGetter,
  actions: commonAction,
  mutations: commonMutation
};

export default commonModule;



// WEBPACK FOOTER //
// ./src/store/jzjy/modules/commonModule.js